module.exports = __webpack_public_path__ + "static/media/fruits-cut1440.121992ea.jpeg";